import type { ProcessStatusConfig } from '../types/process';

export const processStatusConfig: ProcessStatusConfig[] = [
  {
    id: 'initial_interview',
    label: 'Entrevista inicial',
    color: 'bg-blue-100 text-blue-700',
    icon: 'ri-user-voice-line'
  },
  {
    id: 'technical_test',
    label: 'Prueba técnica',
    color: 'bg-purple-100 text-purple-700',
    icon: 'ri-file-list-3-line'
  },
  {
    id: 'client_interview',
    label: 'Entrevista con cliente',
    color: 'bg-orange-100 text-orange-700',
    icon: 'ri-building-line'
  },
  {
    id: 'offer_sent',
    label: 'Oferta enviada',
    color: 'bg-yellow-100 text-yellow-700',
    icon: 'ri-mail-send-line'
  },
  {
    id: 'hired',
    label: 'Contratado',
    color: 'bg-green-100 text-green-700',
    icon: 'ri-checkbox-circle-line'
  },
  {
    id: 'rejected',
    label: 'Descartado',
    color: 'bg-gray-100 text-gray-700',
    icon: 'ri-close-circle-line'
  }
];